export default {
  computed: {
    // Common detection for Sizzling Platter (course 62) store/manager accounts.
    // A manager is any account that has one or more associated stores — either from
    // the user/course payload or the /ws/compliance/stores API. These accounts have
    // read-only profiles.
    isSplatManager () {
      if (Number(process.env.GAME_ID) !== Number(process.env.SIZZLING_PLATTER)) {
        return false
      }
      const course = this.$store.getters['user/getCourses'][process.env.GAME_ID]
      const courseStores = course && course.stores ? course.stores : []
      return courseStores.length > 0 || this.$store.getters['splatReport/getStores'].length > 0
    }
  },
  methods: {
    goToSignupStep (name = 'SignUp', step = '') {
      this.$router.push({name, params: {step}})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/common.js